<template lang="pug">
Teleport(to="body")
  #batch_actions_wrapper(:class="{ in: show }")
    slot
    .actions.ml-auto
      a.select-all(
        href="#"
        data-testid="select-all-activities-button"
        @click.prevent="onSelectAll"
      ) Select all
      a.cancel.valign-middle.ml-15(
        href="#"
        @click.prevent="onCancel"
      )
        i.hi.hi-close.hi-12.text-lighter
</template>

<script>
export default {
  name: 'AppBatchActionsPanel',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select-all', 'cancel'],
  methods: {
    onSelectAll() {
      this.$emit('select-all');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
